import type { Ref } from 'vue';
import { ref } from 'vue';

const loading = ref(false);

export function useGlobalLoading(): { loading: Ref<boolean> } {
  return { loading };
}
